/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { GbcarApiConfiguration as __Configuration } from '../gbcar-api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { GetWineVisitorsResponse } from '../models/get-wine-visitors-response';
import { PageableRequest } from '../models/pageable-request';
import { FileResponseBase } from '../models/file-response-base';
import { WineVisitorDto } from '../models/wine-visitor-dto';
@Injectable({
  providedIn: 'root',
})
class WineVisitorService extends __BaseService {
  static readonly postApiWineVisitorListPath = '/api/WineVisitor/List';
  static readonly getApiWineVisitorExportAllPath = '/api/WineVisitor/ExportAll';
  static readonly putApiWineVisitorPath = '/api/WineVisitor';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param body undefined
   * @return Success
   */
  postApiWineVisitorListResponse(body?: PageableRequest): __Observable<__StrictHttpResponse<GetWineVisitorsResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/WineVisitor/List`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<GetWineVisitorsResponse>;
      })
    );
  }
  /**
   * @param body undefined
   * @return Success
   */
  postApiWineVisitorList(body?: PageableRequest): __Observable<GetWineVisitorsResponse> {
    return this.postApiWineVisitorListResponse(body).pipe(
      __map(_r => _r.body as GetWineVisitorsResponse)
    );
  }

  /**
   * @return Success
   */
  getApiWineVisitorExportAllResponse(): __Observable<__StrictHttpResponse<FileResponseBase>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/WineVisitor/ExportAll`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<FileResponseBase>;
      })
    );
  }
  /**
   * @return Success
   */
  getApiWineVisitorExportAll(): __Observable<FileResponseBase> {
    return this.getApiWineVisitorExportAllResponse().pipe(
      __map(_r => _r.body as FileResponseBase)
    );
  }

  /**
   * @param body undefined
   * @return Success
   */
  putApiWineVisitorResponse(body?: WineVisitorDto): __Observable<__StrictHttpResponse<WineVisitorDto>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/api/WineVisitor`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<WineVisitorDto>;
      })
    );
  }
  /**
   * @param body undefined
   * @return Success
   */
  putApiWineVisitor(body?: WineVisitorDto): __Observable<WineVisitorDto> {
    return this.putApiWineVisitorResponse(body).pipe(
      __map(_r => _r.body as WineVisitorDto)
    );
  }
}

module WineVisitorService {
}

export { WineVisitorService }
